export type StudentOption = {
  id: string;
  label: string;
  emoji?: string;
  note?: string;
  desc?: string;
  sub?: string;
  aliases?: string[];
};

export const STATES = [
  "Johor",
  "Kedah",
  "Kelantan",
  "Melaka",
  "Negeri Sembilan",
  "Pahang",
  "Perak",
  "Perlis",
  "Pulau Pinang",
  "Sabah",
  "Sarawak",
  "Selangor",
  "Terengganu",
  "Kuala Lumpur",
  "Labuan",
  "Putrajaya",
];

export const QUALIFICATIONS: StudentOption[] = [
  {
    id: "Form 4",
    label: "Form 4",
    note: "Early planning - great to start now!",
  },
  { id: "SPM", label: "Form 5 / SPM", note: "" },
  { id: "UEC", label: "UEC", note: "" },
  {
    id: "IGCSE or O-level",
    label: "IGCSE or O-Level",
    note: "",
    aliases: ["O-Level", "IGCSE or O-Level"],
  },
  { id: "STPM", label: "STPM", note: "" },
  { id: "Diploma", label: "Diploma", note: "" },
  { id: "Foundation", label: "Foundation", note: "" },
  { id: "Other", label: "Other", note: "" },
];

export const YEARS = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];

export const SUBJECTS = [
  "Bahasa Melayu",
  "Chinese Language",
  "English Language",
  "Mathematics",
  "Additional Mathematics",
  "Biology",
  "Chemistry",
  "Physics",
  "History",
  "Pendidikan Islam",
  "Pendidikan Moral",
  "Economics",
  "Accounts",
  "Business Studies",
  "Art",
  "Music",
  "Others",
];

export const GRADES = [
  "A+",
  "A",
  "A-",
  "B+",
  "B",
  "B-",
  "C+",
  "C",
  "C-",
  "D",
  "E",
  "G",
];

export const INTERESTS: StudentOption[] = [
  {
    id: "Accounting and Finance",
    label: "Accounting and Finance",
    emoji: "📊",
  },
  {
    id: "Architecture and Built Environment",
    label: "Architecture and Built Environment",
    emoji: "🏛️",
  },
  { id: "Business", label: "Business", emoji: "💼" },
  {
    id: "Communication and Media Studies",
    label: "Communication and Media Studies",
    emoji: "📢",
  },
  { id: "Computing and IT", label: "Computing and IT", emoji: "💻" },
  {
    id: "Creative Arts and Design",
    label: "Creative Arts and Design",
    emoji: "🎨",
  },
  { id: "Education", label: "Education", emoji: "📚" },
  { id: "Engineering", label: "Engineering", emoji: "⚙️" },
  { id: "Foundation", label: "Foundation", emoji: "🎓" },
  {
    id: "Hospitality and Services",
    label: "Hospitality and Services",
    emoji: "🏨",
  },
  {
    id: "International Pre-University",
    label: "International Pre-University",
    emoji: "🌍",
  },
  {
    id: "Language and Social Studies",
    label: "Language and Social Studies",
    emoji: "🗣️",
  },
  { id: "Law", label: "Law", emoji: "⚖️" },
  {
    id: "Medicine and Allied Health Sciences",
    label: "Medicine and Allied Health Sciences",
    emoji: "⚕️",
  },
  {
    id: "Science and Mathematics",
    label: "Science and Mathematics",
    emoji: "🔬",
  },
  { id: "Not sure", label: "Not sure yet", emoji: "🤔" },
  { id: "Other", label: "Other", emoji: "✏️" },
];

export const BUDGETS: StudentOption[] = [
  {
    id: "Below RM20,000",
    label: "Below RM20,000",
    sub: "per year",
    aliases: ["Below RM 20,000/yr"],
  },
  {
    id: "RM20,000 - RM40,000",
    label: "RM20,000 - RM40,000",
    sub: "per year",
    aliases: ["RM 20,000 - RM 40,000/yr"],
  },
  {
    id: "RM40,000 - RM70,000",
    label: "RM40,000 - RM70,000",
    sub: "per year",
    aliases: ["RM 40,000 - RM 70,000/yr"],
  },
  {
    id: "RM70,000 and above",
    label: "RM70,000 and above",
    sub: "per year",
    aliases: ["Above RM 70,000/yr"],
  },
  {
    id: "Need scholarship / rebate",
    label: "Need scholarship / rebate",
    sub: "Help with funding",
    aliases: ["Seeking full scholarship"],
  },
  { id: "Not sure", label: "Not sure yet", sub: "" },
];

export const STEP_LABELS = ["Account", "Academic", "Goals", "Done!"];

export const RESULTS_SPM = [
  "Results not out yet",
  "0-2 As",
  "3-5 As",
  "6-8 As",
  "9 As and above",
  "I am not sure",
  "Other",
];

export const RESULTS_UEC = [
  "Results not out yet",
  "Mostly A/B",
  "Mostly B/C",
  "Mostly C/D",
  "I am not sure",
  "Other",
];

export const RESULTS_CGPA = [
  "CGPA 3.50 and above",
  "CGPA 3.00-3.49",
  "CGPA 2.50-2.99",
  "Below CGPA 2.50",
  "I am not sure",
  "Other",
];

export const LOCATIONS: StudentOption[] = [
  {
    id: "Kuala Lumpur / Selangor",
    label: "Kuala Lumpur / Selangor",
    emoji: "🏙️",
  },
  { id: "Penang", label: "Penang", emoji: "🌴" },
  { id: "Johor", label: "Johor", emoji: "🌆" },
  { id: "Perak", label: "Perak", emoji: "🌿" },
  { id: "Anywhere in Malaysia", label: "Anywhere in Malaysia", emoji: "🇲🇾" },
  { id: "Singapore", label: "Singapore", emoji: "🇸🇬" },
  { id: "Australia", label: "Australia", emoji: "🇦🇺" },
  { id: "UK", label: "UK", emoji: "🇬🇧" },
  { id: "Other overseas", label: "Other overseas", emoji: "🌍" },
  { id: "Not sure", label: "Not sure yet", emoji: "🤔" },
];

export const PATHWAYS: StudentOption[] = [
  {
    id: "Local",
    label: "Local only",
    emoji: "🇲🇾",
    desc: "Study in Malaysia",
  },
  {
    id: "Overseas",
    label: "Overseas only",
    emoji: "🌍",
    desc: "Study abroad",
  },
  { id: "Both", label: "Open to both", emoji: "🌐", desc: "No preference" },
  {
    id: "Not sure",
    label: "Not sure yet",
    emoji: "🤔",
    desc: "Help me decide",
  },
];

export const TIMELINES: StudentOption[] = [
  { id: "As soon as possible", label: "As soon as possible", emoji: "⚡" },
  { id: "Within 3 months", label: "Within 3 months", emoji: "📅" },
  { id: "Within 6 months", label: "Within 6 months", emoji: "🗓️" },
  { id: "Next year", label: "Next year", emoji: "📆" },
  { id: "Just planning early", label: "Just planning early", emoji: "🌱" },
  { id: "Not sure", label: "Not sure yet", emoji: "🤔" },
];

export const PARENT_OPTIONS = ["Yes", "No", "Not yet"];

export const FILLER_OPTIONS = [
  "Student",
  "Parent / Guardian",
  "Student with Parent",
];

export const COURSE_DIRECTIONS: Record<
  string,
  Array<{ name: string; desc: string }>
> = {
  business: [
    {
      name: "Business Management",
      desc: "Lead, plan and manage organisations across industries.",
    },
    {
      name: "Marketing",
      desc: "Consumer behaviour, branding and digital marketing strategy.",
    },
    {
      name: "International Business",
      desc: "Global markets, trade and cross-border business practices.",
    },
    {
      name: "Digital Business",
      desc: "Business strategy combined with technology and e-commerce.",
    },
    {
      name: "Human Resource Management",
      desc: "People management, recruitment and organisational culture.",
    },
  ],
  accounting: [
    {
      name: "Accounting",
      desc: "Financial reporting, auditing and accounting principles.",
    },
    {
      name: "Finance & Banking",
      desc: "Financial markets, investment and banking operations.",
    },
    {
      name: "Actuarial Science",
      desc: "Apply maths and statistics to financial risk and insurance.",
    },
    {
      name: "Economics",
      desc: "Economic systems, policy and market behaviour.",
    },
  ],
  it: [
    {
      name: "Computer Science",
      desc: "Core programming, algorithms and software systems.",
    },
    {
      name: "Software Engineering",
      desc: "Build and design software products and applications.",
    },
    {
      name: "Cybersecurity",
      desc: "Protect systems, networks and data from digital threats.",
    },
    {
      name: "Data Analytics / AI",
      desc: "Analyse data and build intelligent systems.",
    },
    {
      name: "Information Technology",
      desc: "Networks, systems and IT support across all industries.",
    },
  ],
  engineering: [
    {
      name: "Mechanical Engineering",
      desc: "Design and build mechanical systems and machinery.",
    },
    {
      name: "Electrical Engineering",
      desc: "Work with circuits, power systems and electronics.",
    },
    {
      name: "Civil Engineering",
      desc: "Design infrastructure - buildings, roads and bridges.",
    },
    {
      name: "Chemical Engineering",
      desc: "Apply chemistry to industrial processes and manufacturing.",
    },
  ],
  design: [
    {
      name: "Graphic Design",
      desc: "Visual communications for digital and print media.",
    },
    {
      name: "Interior Design",
      desc: "Functional and aesthetic interior spaces.",
    },
    {
      name: "Animation & Digital Media",
      desc: "Animations, games and interactive content.",
    },
    {
      name: "Fashion Design",
      desc: "Clothing and accessories for the fashion industry.",
    },
  ],
  psychology: [
    {
      name: "Psychology",
      desc: "Human behaviour, cognition and mental processes.",
    },
    {
      name: "Counselling",
      desc: "Therapeutic approaches and mental health support.",
    },
    {
      name: "Social Work",
      desc: "Support individuals and communities facing social challenges.",
    },
    {
      name: "Criminology",
      desc: "Crime, criminal behaviour and justice systems.",
    },
  ],
  law: [
    {
      name: "Law (LLB)",
      desc: "Qualify as a lawyer with a broad legal education.",
    },
    {
      name: "Islamic Law / Syariah",
      desc: "Islamic jurisprudence and legal principles.",
    },
    { name: "Legal Studies", desc: "Understand the legal system." },
  ],
  mass_comm: [
    {
      name: "Mass Communication",
      desc: "Journalism, PR, advertising and media production.",
    },
    {
      name: "Journalism",
      desc: "Report and produce news for print, broadcast and digital.",
    },
    {
      name: "Public Relations",
      desc: "Manage reputation, communications and media relations.",
    },
    {
      name: "Broadcasting & Film",
      desc: "Produce TV, radio and film content.",
    },
  ],
  hospitality: [
    {
      name: "Hotel Management",
      desc: "Run hotels, resorts and accommodation businesses.",
    },
    {
      name: "Tourism Management",
      desc: "Manage travel, tourism services and destinations.",
    },
    {
      name: "Culinary Arts",
      desc: "Train as a chef and food service professional.",
    },
    {
      name: "Event Management",
      desc: "Plan and manage corporate and entertainment events.",
    },
  ],
  health: [
    {
      name: "Biomedical Science",
      desc: "Disease, diagnostics and lab-based health science.",
    },
    {
      name: "Nursing",
      desc: "Patient care and clinical support in healthcare settings.",
    },
    {
      name: "Physiotherapy",
      desc: "Help patients recover through movement and rehabilitation.",
    },
    {
      name: "Medical Lab Technology",
      desc: "Carry out diagnostic lab tests and analysis.",
    },
  ],
  medicine: [
    {
      name: "Medicine (MBBS)",
      desc: "Train to become a medical doctor over 5-6 years.",
    },
    {
      name: "Pharmacy",
      desc: "Drug preparation, dispensing and pharmaceutical care.",
    },
    { name: "Dentistry", desc: "Oral health diagnosis and treatment." },
  ],
  education: [
    {
      name: "Early Childhood Education",
      desc: "Teach and support young children aged 0-8.",
    },
    {
      name: "Primary / Secondary Education",
      desc: "Train to teach in school settings.",
    },
    {
      name: "TESL / TESOL",
      desc: "Teach English as a second or foreign language.",
    },
  ],
  not_sure: [
    {
      name: "Business",
      desc: "Broad and flexible - suitable for many career paths.",
    },
    {
      name: "IT / Computer Science",
      desc: "High demand globally with strong career growth.",
    },
    {
      name: "Psychology",
      desc: "Understand people - opens doors to counselling, HR and more.",
    },
    {
      name: "Design / Creative",
      desc: "Creative fields with growing digital demand.",
    },
    {
      name: "Mass Communication",
      desc: "Media, PR and communications - diverse career paths.",
    },
    {
      name: "Hospitality / Tourism",
      desc: "Fast-growing industry with global opportunities.",
    },
  ],
  other: [
    {
      name: "Business",
      desc: "Broad and flexible - suitable for many career paths.",
    },
    {
      name: "IT / Computer Science",
      desc: "High demand globally with strong career growth.",
    },
    {
      name: "Design / Creative",
      desc: "Creative fields with growing digital demand.",
    },
    {
      name: "Social Sciences",
      desc: "Study society, culture and human behaviour.",
    },
  ],
};
